import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  userDetails: any;
  businessData: any;
  locale: any;
  private updatedStatusSubject = new BehaviorSubject<boolean>(false);
  updatedStatus$ = this.updatedStatusSubject.asObservable();

  private isHolcimUserSubject = new BehaviorSubject<boolean>(false);
  isHolcimUser$ = this.isHolcimUserSubject.asObservable();
  setUpdatedStatus(status: boolean): void {
    console.log(status);

    this.updatedStatusSubject.next(status);
  }

  setHolcimUser(isHolcimUser: boolean): void {
    console.log(isHolcimUser);
    this.isHolcimUserSubject.next(isHolcimUser);
  }
  constructor(private store: Store<any>) {
    // this.userDetails = JSON.parse(localStorage.getItem('userDetails')!)
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.userDetails = data?.authReducer?.userDetails;
        this.businessData = data.authReducer.businessDetails;
        this.locale = data?.authReducer?.localLanguage?.locale;
      });
  }

  formattedPrice(amount) {
    const locale = this.locale === 'ar-AE' || this.locale === 'ar-UG' ? 'ar-EG' : this.locale;
    const thousandSep = new Intl.NumberFormat(locale, {
      maximumFractionDigits: 2,
    }).format(amount || 0);
    return {
      currency: this.businessData?.currency,
      amount: thousandSep || 0,
      notAmount: !isNaN(parseFloat(thousandSep)) ? thousandSep.replace(/,/g, '') || 0 : amount
    };
  }

  formattedPriceWithFactor(amount) {
    const locale = this.locale === 'ar-AE' || this.locale === 'ar-UG' ? 'ar-EG' : this.locale;
    const thousandSep = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
    return {
      currency: this.businessData?.currency,
      amount: thousandSep || 0,
      notAmount: !isNaN(parseFloat(thousandSep)) ? thousandSep.replace(/,/g, '') || 0 : amount
    };
  }

  formattedDocumnetNumber(amount) {
    const locale = this.locale === 'ar-AE' || this.locale === 'ar-UG' ? 'ar-EG' : this.locale;
    const [mainPart, subPart] = amount.split('-').map(Number);
    const formattedMainPart = new Intl.NumberFormat(locale, {
      maximumFractionDigits: 2,
      useGrouping: false
    }).format(mainPart);
    const formattedSubPart: any = new Intl.NumberFormat(locale, {
      maximumFractionDigits: 2
    }).format(subPart);
    let docNumber = !isNaN(formattedSubPart) ? `${formattedMainPart}-${formattedSubPart}` : `${formattedMainPart}`
    console.log(docNumber);

    return {
      docNumber: docNumber
    };
  }
  formattedPriceProduct(amount, currency) {

    let output = '';
    const locale = this.locale === 'ar-AE' || this.locale === 'ar-UG' ? 'ar-EG' : this.locale;
    const thousandSep = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
    return {
      currency: currency ?? this.businessData?.currency,
      amount: thousandSep || 0,
      notAmount: thousandSep.replace(/,/g, '') || 0,
    };
  }

  FIND_REVERSE_INCOTERM_TYPE(type: any) {
    console.log();

    if (type === 'delivered' || type === 'MDD') {
      return 'DDP';
    } else if (type === 'agency') {
      return 'FCA';
    } else if (type == 'DAP') {
      return 'DAP';
    }
    return 'EXW';
  }
}
